// DS: C37
/** Container used to display a deviation using the entire page width */
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationType } from '../DeviationViews/_helpers';
import { DeviationTypes } from '../types/deviation';
import DesktopArtStage from './DesktopArtStage';
import DesktopTextualArtStage from './DesktopTextualArtStage';
import CommissionMobileArtStage from './CommissionMobileArtStage';
import MobileArtStage from './MobileArtStage';
import CommissionStage from './CommissionStage';
import SimpleStage from './_partials/SimpleStage';
var ArtStage = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner, className = _a.className, isZoomed = _a.isZoomed, onEnterZoomMode = _a.onEnterZoomMode, onExitZoomMode = _a.onExitZoomMode;
    var isMobile = useContext(MobileContext);
    var deviationType = getDeviationType(deviation);
    if (isMobile) {
        return deviationType === DeviationTypes.COMMISSION ? (React.createElement(CommissionMobileArtStage, { deviation: deviation, className: className })) : (React.createElement(MobileArtStage, { deviation: deviation, className: className, isZoomed: isZoomed, onEnterZoomMode: function () { return onEnterZoomMode(deviation); }, onExitZoomMode: function () { return onExitZoomMode(deviation); } }));
    }
    switch (getDeviationType(deviation)) {
        case DeviationTypes.POLL:
        case DeviationTypes.STATUS:
            return React.createElement(SimpleStage, { deviation: deviation });
        case DeviationTypes.COMMISSION:
            return React.createElement(CommissionStage, { deviation: deviation });
        case DeviationTypes.TIER:
        case DeviationTypes.JOURNAL:
        case DeviationTypes.LITERATURE:
            return (React.createElement(DesktopTextualArtStage, { deviation: deviation, className: className }));
        default:
            return (React.createElement(DesktopArtStage, { deviation: deviation, isOwner: isOwner, className: className, isZoomed: isZoomed, onEnterZoomMode: function () { return onEnterZoomMode(deviation); }, onExitZoomMode: function () { return onExitZoomMode(deviation); } }));
    }
};
ArtStage.displayName = 'ArtStage';
export default ArtStage;
//# sourceMappingURL=ArtStage.js.map